import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/home/home-bg.jpg'


const _withScopeId = n => (_pushScopeId("data-v-7d828a3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Home view-default" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Home__Background" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    width: "2572",
    height: "1770"
  })
], -1))
const _hoisted_3 = { class: "Home__Inner view-default__inner" }
const _hoisted_4 = { class: "Home__Partnership small-caps" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = {
  href: "https://about.facebook.com/",
  rel: "nofollow noopener",
  target: "_blank"
}
const _hoisted_7 = { class: "Home__ExhibitionName" }
const _hoisted_8 = { class: "Home__Cta" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "Home__Logo" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PreLoader = _resolveComponent("PreLoader")!
  const _component_ui_icon = _resolveComponent("ui-icon")!
  const _component_heading = _resolveComponent("heading")!
  const _component_ui_btn = _resolveComponent("ui-btn")!
  const _component_ArtistName = _resolveComponent("ArtistName")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PreLoader, { onDone: _ctx.onPreloadComplete }, null, 8, ["onDone"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('common.partnership')), 1),
          _createElementVNode("a", _hoisted_6, [
            _createVNode(_component_ui_icon, { name: "logo-meta" })
          ])
        ]),
        _createVNode(_component_ArtistName, { class: "Home__ArtistName" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_heading, { key: _ctx.locale }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.exhibition_name')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_ui_btn, { onClick: _ctx.onStart }, {
                default: _withCtx(() => [
                  _createElementVNode("span", { innerHTML: _ctx.ctaLabel }, null, 8, _hoisted_9)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_ui_icon, { name: "logo-freunde-der-nationalgalerie" })
        ])
      ])
    ])
  ], 64))
}